import React from 'react'

import { rem } from 'config/stitches.config'
import SectionContainer from '@/Section/Container'
import CustomImage from '@/UI/Image'

const SimpleContent = ({
  sectionGeneral: { theme },
  sectionHeader,
  sectionContent,
}) => (
  <SectionContainer
    theme={theme}
    sectionHeader={sectionHeader}
    containerProps={{
      css: {
        paddingBottom: rem(40),
        '@md': { paddingBottom: rem(80) },
      },
    }}
  >
    {
      sectionContent.media &&
      <CustomImage rounded="normal" {...sectionContent.media}/>
    }
  </SectionContainer>
)

export default SimpleContent
